import { Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import {
  tableCellArrowSx,
  tableCellTooltipSx
} from "src/components/TableCellComponents/style";

const CellWithEllipsis = ({
  rowData,
  id,
  cellWidth
}: {
  rowData: any;
  id: string | number;
  cellWidth?: string;
}) => {
  // Create Ref
  const textElementRef = useRef(null);

  const compareSize = () => {
    const compare =
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(compare);
  };

  // compare once and add resize listener on "componentDidMount"
  useEffect(() => {
    compareSize();
    window?.addEventListener("resize", compareSize);
    return () => {
      window?.removeEventListener("resize", compareSize);
    };
  }, []);

  // Define state and function to update the value
  const [hoverStatus, setHover] = useState(false);

  return (
    <Tooltip
      title={rowData[id]}
      disableHoverListener={!hoverStatus}
      placement="bottom-start"
      slotProps={{
        tooltip: { sx: tableCellTooltipSx },
        arrow: { sx: tableCellArrowSx }
      }}
      arrow
    >
      <Typography
        variant="subtitle2"
        color="grey.900"
        fontWeight={"normal"}
        ref={textElementRef}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: `${cellWidth || "90%"}`
        }}
      >
        {rowData[id]}
      </Typography>
    </Tooltip>
  );
};

export default CellWithEllipsis;
